import { Signal, createSignal } from 'solid-js'
import { memoGeneratorBtn as api } from 'st-app/api'
import { WritingStyle } from 'st-app/api';

const [writingStyles, setWritingStyles] = createSignal<Array<WritingStyle>>();

let writingStylesInitialized = false;
export class MemoStore {
    constructor() {
        if (!writingStylesInitialized) {
            writingStylesInitialized = true;
            api.GetWritingStyles().then(styles => {
                setWritingStyles(styles);
            }).catch(console.error);
        }
    }

    get styles() { return writingStyles() || []; }

    myWritingStyle(): WritingStyle {
        return this.styles[0] || new WritingStyle();
    }

    getWritingStyle(id: string) {
        return this.styles.find(ws => ws.writingStyleGU === id) || this.myWritingStyle();
    }

    setMyWritingStyle(style: WritingStyle) {
        api.SaveWritingStyle(style);

        const [myStyle, ...otherStyles] = this.styles;
        setWritingStyles([style, ...otherStyles])
    }
}
